import React from 'react';
import logo from '../../../../assets/MyBakeOven.svg';
import HeaderIcon, {
  HeaderIconProps,
} from '../../../../../../components/auth/AuthLayout/HeaderIcon/HeaderIcon';

function HeaderIconMyBakery(props: HeaderIconProps) {
  return <HeaderIcon {...props} logoIcon={logo} title="" />;
}
export default HeaderIconMyBakery;
